/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getKategorijaDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// KategorijaRepromaterijalaDropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const KategorijaRepromaterijalaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [kategorijaRepromaterijalaDropdown, setKategorijaRepromaterijalaDropdown] = useState<
    Array<Option>
  >([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getKategorijaDropdown()
        setKategorijaRepromaterijalaDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching Kvalitet Materijala dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={kategorijaRepromaterijalaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'KategorijaRepromaterijalaDropdown'}
      errors={errors}
      placeholder='Odaberi Kategoriju Rolni'
      touched={touched}
    />
  )
}

export default KategorijaRepromaterijalaDropdown
